import classNames from 'classnames';
import React from 'react';
import { Colors } from './color';

interface TextAlignProps {
  alignLeft?: boolean;
  alignCenter?: boolean;
  alignRight?: boolean;
}

interface TypographyProps extends TextAlignProps {
  children: React.ReactNode;
  className?: string;
  color?: Colors;
  as?: React.ElementType<any>;
}

function getTextAlignClass({ alignLeft, alignCenter, alignRight }: TextAlignProps) {
  if (alignLeft) return 'textAlignLeft';
  if (alignCenter) return 'textAlignCenter';
  if (alignRight) return 'textAlignRight';
  return null;
}

export const createTypographyComponent = (
  defaultElement: React.ElementType<any>,
  baseClass: string,
  displayName: string,
): React.FC<TypographyProps> => {
  const Component: React.FC<TypographyProps> = ({
    as,
    children,
    className,
    color,
    ...alignProps
  }) => {
    const UsedElement = as ?? defaultElement;

    return React.createElement(
      UsedElement,
      {
        className: classNames(
          `text-${baseClass}`,
          getTextAlignClass(alignProps),
          {
            [`color-${color}`]: !!color,
          },
          className,
        ),
      },
      children,
    );
  };
  Component.displayName = displayName;
  return Component;
};
